module.exports = "/images/icon_ourstory_2_new2.png?6c159fbf5e86e1ec835ed92f1f7b65e7";